import { useMediaQuery, useTheme } from '@mui/material';

const useBreakpoint = breakpoint => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(breakpoint));
};

export default useBreakpoint;
